import { useState, useEffect } from 'react'
import storageService from '../services/storageService'
import { getUserCapabilitiesAndNationalIdStatus } from '../adapters/user'

export const useUserStatuses = (updateUser) => {
  const [isLoading, setIsLoading] = useState(true)
  const [user, setUser] = useState(storageService.getUser())

  useEffect(() => {
    const fetchUserStatuses = async () => {
      setIsLoading(true)
      const response = await getUserCapabilitiesAndNationalIdStatus()

      if (response.ok) {
        const { deposit, national_id_status } = response.data.data
        const updatedUser = {
          ...user,
          national_id_status,
          user_capabilities: {
            ...user?.user_capabilities,
            deposit,
          },
        }

        setUser(updatedUser)
        updateUser(updatedUser)
      }
      setIsLoading(false)
    }

    if (
      user?.national_id_status === 'PROCESSING' ||
      user?.national_id_status === 'REQUIRED'
    ) {
      fetchUserStatuses()
    } else {
      setIsLoading(false)
    }
  }, [user, updateUser])

  return { user, isLoading }
}